<template>
  <div>
    <h1>{{ pageHeader }}</h1>

    <form class="lihavapp-form">
      <div class="form-group">
        <label for="systolic">Systolic pressure in mmHg</label>
        <input
          type="number"
          class="form-control"
          id="systolic"
          name="systolic"
          v-model.number="systolic"
          required
          :disabled="showModeActive"
        />
      </div>

      <div class="form-group">
        <label for="diastolic">Diastolic pressure in mmHg</label>
        <input
          type="number"
          class="form-control"
          id="diastolic"
          name="diastolic"
          v-model.number="diastolic"
          required
          :disabled="showModeActive"
        />
      </div>

      <section>
        <div class="form-group">
          <label for="date">Measurement date</label>
          <input
            type="date"
            v-model="date"
            class="form-control"
            placeholder="Select date"
            :disabled="showModeActive"
          />
        </div>

        <div class="form-group">
          <label>Measurement time (optional)</label>
          <div class="input-group mb-3">
            <input
              type="time"
              class="form-control"
              id="time"
              name="time"
              placeholder
              v-model="time"
              required
              :disabled="showModeActive"
              step="60"
            />
            <div class="input-group-append">
              <button
                class="btn btn-outline-secondary"
                type="button"
                v-on:click="clearTime()"
                :disabled="showModeActive"
              >Clear</button>
            </div>
          </div>
        </div>

        <div class="form-group">
          <label>Comment (optional)</label>
          <input
            class="form-control"
            type="text"
            name="comment"
            v-model="comment"
            :disabled="showModeActive"
          />
        </div>
      </section>

      <div class="form-group lihavapp-form-control-button-holder">
        <button
          type="button"
          class="btn btn-primary mr-3"
          v-on:click="create()"
          v-if="createModeActive"
        >Create</button>

        <button
          type="button"
          class="btn btn-secondary mr-3"
          v-on:click="update()"
          v-if="editModeActive"
        >Update</button>

        <button
          type="button"
          class="btn btn-outline-secondary"
          v-on:click="cancel()"
          v-if="createModeActive || editModeActive"
        >Cancel</button>

        <button
          type="button"
          class="btn btn-outline-danger float-right"
          v-on:click="deleteMeasurement"
          v-if="editModeActive"
        >Delete</button>

        <button
          type="button"
          class="btn btn-secondary"
          v-on:click="$router.push({ name: 'blood-pressure' });"
          v-if="showModeActive"
        >Back</button>

        <button
          type="button"
          class="btn btn-outline-secondary float-right"
          v-on:click="edit()"
          v-if="showModeActive"
        >Edit measurement</button>
      </div>
    </form>
  </div>
</template>

<script>
import { store } from "@/store.js";

export default {
  name: "BloodPressureShowCreateEdit",
  components: {},
  data: function() {
    return {
      store: store,
      systolic: null,
      diastolic: null,
      comment: "",
      bloodPressureMeasurement: {
        systolic: "",
        diastolic: "",
        time: "",
        date: ""
      },
      date: this.moment().format("YYYY-MM-DD"),
      time: this.moment().format("HH:mm")
    };
  },
  created: function() {},
  mounted: function() {
    if (this.showModeActive || this.editModeActive) {
      let object = this.store.getBloodPressureMeasurement(this.$route.params.id);

      if (object == undefined) {
        return;
      }

      this.systolic = (object.systolic);
      this.diastolic = (object.diastolic);

      this.date = this.moment(object.date).format("YYYY-MM-DD");

      if (object.time)
        this.time = this.moment(object.time, "HH:mm:ss").format("HH:mm");
      else this.time = null;

      this.comment = object.comment;
    }
  },
  computed: {
    showModeActive: function() {
      return this.$route.name == "blood-pressure.show";
    },
    createModeActive: function() {
      return this.$route.name == "blood-pressure.create";
    },
    editModeActive: function() {
      return this.$route.name == "blood-pressure.edit";
    },
    pageHeader: function() {
      if (this.showModeActive) {
        return "Show blood pressure measurement";
      }

      if (this.editModeActive) {
        return "Edit blood pressure measurement";
      }

      return "Add new blood pressure measurement";
    }
  },
  methods: {
    updateMeasurementObject: function() {
      this.bloodPressureMeasurement.systolic = Math.round(this.systolic);
      this.bloodPressureMeasurement.diastolic = Math.round(this.diastolic);

      this.bloodPressureMeasurement.time = this.time; //this.moment(this.time).format("HH:mm");

      this.bloodPressureMeasurement.date = this.date; //this.moment(this.date).format("D.M.YYYY");
      this.bloodPressureMeasurement.comment = this.comment;
    },
    create: function() {
      this.updateMeasurementObject();

      let self = this;
      this.axios
        .post("/bloodpressure", this.bloodPressureMeasurement)
        .then(function(response) {
          let measurement = response.data;
          self.store.addBloodPressureMeasurement(measurement);
          self.flashSuccess("New blood pressure measurement stored successfully");
          self.$router.push({ name: "blood-pressure" });
        })
        .catch(function(error) {
          self.flashError(error.response.data.message);
        })
        .then(function() {
          // always executed
        });
    },
    edit: function() {
      this.$router.push({
        name: "blood-pressure.edit",
        params: { id: this.$route.params.id }
      });
    },
    update: function() {
      this.updateMeasurementObject();

      let self = this;
      this.axios
        .put("/bloodpressure/" + this.$route.params.id, this.bloodPressureMeasurement)
        .then(function(response) {
          let updated = response.data;

          if (self.store.updateBloodPressureMeasurement(updated)) {
            self.flashSuccess("Blood pressure measurement updated successfully");
            self.$router.push({ name: "blood-pressure" });
          } else {
            self.flashError(
              "Failed to update blood pressure measurement data structure"
            );
          }
        })
        .catch(function(error) {
          self.flashError(error.response.data.message);
        })
        .then(function() {
          // always executed
        });
    },
    cancel: function() {
      if (this.editModeActive) {
        this.$router.push({
          name: "blood-pressure.show",
          params: { id: this.$route.params.id }
        });
      } else {
        let returnRoute = "blood-pressure";

        if (this.store.state.bloodPressureView.cancelRoute)
        {
          returnRoute = this.store.state.bloodPressureView.cancelRoute;
        }

        this.$router.push({ name: returnRoute });
      }
    },

    deleteMeasurement: function() {
      if (!this.editModeActive) return;

      let measurement = this.store.getBloodPressureMeasurement(this.$route.params.id);

      if (measurement == undefined) {
        return;
      }
      let confirmationText =
        "Are you sure that you want to delete this blood pressure measurement?";

      if (!confirm(confirmationText)) {
        return;
      }

      var self = this;
      this.axios
        .delete("/bloodpressure/" + measurement.id)
        .then(function(response) {
          // handle success
          let removed = self.store.removeBloodPressureMeasurement(measurement.id);

          if (removed) {
            self.flashSuccess("Blood pressure measurement deleted successfully");
          } else {
            self.flashSuccess(
              "Blood pressure measurement removed from server, but deleting from local data structure failed"
            );
          }

          self.$router.push({ name: "blood-pressure" });
        })
        .catch(function(error) {
          self.flashError(error.response.data.message);
        })
        .then(function() {
          // always executed
        });
    },
    clearTime: function() {
      this.time = "";
    }
  }
};
</script>

<style scoped>
</style>